module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posi"
  }, [_c('div', {
    ref: "city",
    staticClass: "city"
  }, [_c('list-view', {
    ref: "list",
    attrs: {
      "data": _vm.singersc
    },
    on: {
      "select": _vm.selectc
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4763d2cb"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/station.vue
// module id = 401
// module chunks = 1